export default ["42 (XS)","44 (S)", "46 (M)", "48 (M/L)", "50 (L)", "52+ (XL)"]